import { z } from 'zod';

export const PullDirectionSchema = z.object({
  x: z.number(),
  y: z.number(),
  z: z.number(),
});

export type PullDirection = z.infer<typeof PullDirectionSchema>;
